import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SearchChartIcon = createIcon({
  displayName: 'SearchChartIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M16.747,6.187c2.916,2.916 2.916,7.644 0,10.56c-2.916,2.916 -7.644,2.916 -10.56,0c-2.916,-2.916 -2.916,-7.644 0,-10.56c2.916,-2.916 7.644,-2.916 10.56,8.88178e-16"></path>
        <path d="M7.93,12.89v-1"></path>
        <path d="M11.25,12.89v-2"></path>
        <path d="M14.57,12.89v-3"></path>
        <path d="M20,20l-3.25,-3.25"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const SearchChart: FC<IconProps> = (props) => {
  return <CustomIcon as={SearchChartIcon} {...props} />
}

export default memo(SearchChart)
